import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import Scroll from 'vuetify/lib/directives/scroll';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ma-2"},[_c(VBtn,{directives:[{def: Scroll,name:"scroll",rawName:"v-scroll",value:(_setup.onScroll),expression:"onScroll"},{name:"show",rawName:"v-show",value:(_setup.visible),expression:"visible"}],attrs:{"fab":"","fixed":"","bottom":"","right":"","outlined":"","color":"primary"},on:{"click":_setup.goTop}},[_c(VIcon,[_vm._v("keyboard_arrow_up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }